module.exports = __webpack_public_path__ + "static/media/cardMatka.74d615bf.png";